import { render, staticRenderFns } from "./veStuGraduationByzbhRule.vue?vue&type=template&id=6d88759b&scoped=true"
import script from "./veStuGraduationByzbhRule.vue?vue&type=script&lang=js"
export * from "./veStuGraduationByzbhRule.vue?vue&type=script&lang=js"
import style0 from "./veStuGraduationByzbhRule.vue?vue&type=style&index=0&id=6d88759b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d88759b",
  null
  
)

export default component.exports